import styles from "@styles/home/heroBanner.module.scss";

const generateNewBannerHtml = () => `
  <section class="${styles.betterthatBanner}">
    <div class="${styles.bannerContent}">
      <div class="${styles.contentWrapper}">
        <div class="${styles.textContent}">
          <h3><strong>Shop for Good: Support Fishing Communities and Beyond</strong></h3>
          <p> Discover a world of amazing products and <strong>make a positive impact</strong> with our new e-commerce marketplace, powered by Better That Connect.</p>
          <p><strong>How it works:</strong><br> Every purchase you make <strong>directly supports the Fishing in Godzone community.</strong> We receive a portion of the platform's commission, not from your purchase price. It's a simple way to <strong>shop with purpose.</strong></p>
         <p><strong>Bonus:</strong> <br> With each purchase, the platform donates up to 15% of their commission to a charity of your choice. </p>
        <p><strong>Start shopping today and make a difference!</strong> </p>
<!--           <a class="${styles.customBatn}" href="/products">Shop Now</a>-->
        </div>

        <div class="${styles.imageContent}">
          <img src="/img/steinlager_mangawhai.webp" alt="Betterthat illustration" />
        </div>
      </div>
    </div>
  </section>
        <div class="heading-section lulaBg text-center" >
        Shop Now
        </div>
`;
export const replaceBanner = (data) => {
  if (!data || !data.raw_data) {
    return data;
  }

  try {
    const rawData = JSON.parse(data.raw_data);
    if (Array.isArray(rawData.blocks)) {
      const newBannerHtml = generateNewBannerHtml();

      rawData.blocks = rawData.blocks.map((block) => {
        if (
          block.includes('class="shop-now-block"') &&
          block.includes('data-block-type="home_new"') &&
          block.includes('data-id="1"')
        ) {
          return newBannerHtml;
        }

        if (block.includes('class="proud_title"')) {
          return block.replace(/Better That/g, "Fishing in Godzone");
        }
        return block;
      });

      return {
        ...data,
        raw_data: JSON.stringify(rawData),
      };
    }
  } catch (error) {
    console.error("Error parsing or modifying raw_data:", error);
  }

  return data;
};
